import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printTable } from '../../output.js'

export const workspacesListCommand = new Command(`list`)
  .description(`List accessible workspaces`)
  .action(async () => {
    const json = workspacesListCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.workspaces.list({})

      if (isQuiet()) {
        for (const w of result.workspaces) {
          printQuiet(w.id)
        }
        return
      }

      if (json) {
        printJson(result)
      } else {
        printTable(
          [`ID`, `Name`, `Created`],
          result.workspaces.map((w) => [w.id, w.name, w.createdAt.slice(0, 10)])
        )
      }
    } catch (error) {
      handleError(error, json)
    }
  })
